import React from 'react'
import { cn } from '@utils/cn'

export const Container = ({ children, className, ...props }: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div className={cn('container mx-auto px-2', className)} {...props}>
      {children}
    </div>
  )
}

export const ContainerFullWidth = ({ children, className, ...props }: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div className={cn('w-full', className)} {...props}>
      {children}
    </div>
  )
}
